import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TabsWidgetV2: WidgetRegistryEntry = {
  name: "TabsV2",
  configuration: () => import("./configuration").then((m) => m.TabsWidgetV2Configuration),
  component: () => import("./tabs-widget-v2.component").then((m) => m.TabsWidgetV2Component)
};
